import React, { createContext, useState, useContext } from 'react'
import { useConfig } from './ConfigProvider'
import { ActivateAccount, CreateNewAccount, GetCustomersByTaxId } from '../Services/RegistrationService'


const RegistrationContext = createContext()
export const useRegistration = () => {
  return useContext(RegistrationContext)
}

export const RegistrationProvider = ({ children }) => {

  const { api } = useConfig()
  const [isLoadingGetCustomersByTaxId, setIsLoadingGetCustomersByTaxId] = useState(false)
  const [errorGetCustomersByTaxId, setErrorGetCustomersByTaxId] = useState("")
  const [registrationCustomer, setRegistrationCustomer] = useState({ name: '', surname: '', email: '', password: '', phone: '', taxId: '', marketingAgree: false, marketingAgreeEmail: false, marketingAgreePhone: false, marketingAgreeSms: false, fromGus: false, companyInfo: { taxId: '', regon: '', companyName: '', companyShortName: '', province: '', zipCode: '', city: '', street: '', houseNumber: '', localNumber: '', custId: '', country: '', fromGus: false, custId: '' }, custId: '' })
  const [registrationInfoVM, setRegistrationInfoVM] = useState({
    accountExists: false,
    possibleCompanies: [],
    Error: ''
  });

  const clearRegistrationInfoVM = () => {
    setRegistrationInfoVM({
      accountExists: false,
      possibleCompanies: [],
      Error: ''
    })
  }

  const getCustomersByTaxId = async (taxId) => {
    try {
      setErrorGetCustomersByTaxId('')
      setIsLoadingGetCustomersByTaxId(true);
      const result = await GetCustomersByTaxId(api, taxId)
      if (result.data.possibleCompanies) {
        setRegistrationInfoVM(result.data)
        setIsLoadingGetCustomersByTaxId(false);
      }
      else {
        setErrorGetCustomersByTaxId(result.data.error)
        setIsLoadingGetCustomersByTaxId(false);
      }

    }
    catch (error) {
      console.log(error)
      setErrorGetCustomersByTaxId('Błąd wyszukiwania NIPu!')
      setIsLoadingGetCustomersByTaxId(false);
    }
  };

  const createNewAccount = async (data) => {
    try {
      const result = await CreateNewAccount(api, data)
      const apiData = result.data
      return { success: apiData.success, error: apiData.error, authUserVM: apiData.authUserVM }
    } catch (error) {
      console.log(error)
      return { success: false, error: null }
    }
  };

  const activateAccount = async (link) => {
    try {
      const result = await ActivateAccount(api, link)
      return result.data
    }
    catch (error) {
      console.log(error)
      return { result: false, errorMessage: 'Błąd aktywacji konta, skontaktuj się z administratorem.' }
    }
  }

  return (
    <RegistrationContext.Provider value={{
      registrationInfoVM,
      registrationCustomer,
      errorGetCustomersByTaxId,
      isLoadingGetCustomersByTaxId,
      activateAccount,
      setRegistrationCustomer,
      createNewAccount,
      getCustomersByTaxId,
      clearRegistrationInfoVM,
    }}>
      {children}
    </RegistrationContext.Provider>
  )
}
